import { onError } from '@apollo/client/link/error';
function getDefaultErrorHandler(logger, openQueryChecker) {
  return onError(({
    graphQLErrors,
    networkError,
    operation
  }) => {
    const {
      requestId
    } = operation.getContext();
    const log = setupLogger(requestId, operation);
    finishRequest(operation, log);
  });
  function finishRequest(operation, log) {
    openQueryChecker.openQueries.delete(operation.getContext().requestId);
    if (!log) return;
    const responseTime = (new Date() - operation.getContext().start) / 1000;
    log(`GraphQL Response failed taking: ${responseTime}s`);
  }
  function setupLogger(requestId, operation) {
    if (!logger.enabled) return null;
    return logger.extend(requestId);
  }
}
export default getDefaultErrorHandler;
//# sourceMappingURL=get-default-error-handler.js.map